import { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import '../../css/BeforeAfter.css';
import '../../css/BeforeAfterGallery.css';
import Footer from '../footer/Footer';
import Header from '../Header';

const IMAGE_DIR = '/img/before-after/2026_01_deauville';

// Chaque image regroupe déjà le "avant" (moitié gauche) et le "après" (moitié droite)
const images = [
    'before_after_2026_january_deauville_1.png',
    'before_after_2026_january_deauville_2.png',
    'before_after_2026_january_deauville_3.png',
];

const DeauvilleJanuary2026 = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const close = useCallback(() => setOpenIndex(null), []);
    const next = useCallback(() => setOpenIndex((i) => (i + 1) % images.length), []);
    const prev = useCallback(() => setOpenIndex((i) => (i - 1 + images.length) % images.length), []);

    useEffect(() => {
        if (openIndex === null) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') close();
            if (e.key === 'ArrowRight') next();
            if (e.key === 'ArrowLeft') prev();
        };
        document.addEventListener('keydown', onKey);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', onKey);
            document.body.style.overflow = '';
        };
    }, [openIndex, close, next, prev]);

    return (
        <>
            <Helmet>
                <title>Débarras Quai de la Touques – Deauville (01/2026) | CC Débarras 14</title>
                <meta name="description" content="Débarras d'une propriété sur le quai de la Touques à Deauville en janvier 2026 : vide-maison, évacuation de meubles et encombrants. Photos avant/après de l'intervention CC Débarras 14." />
                <link rel="canonical" href="https://ccdebarras14.fr/avant-apres/deauville-janvier-2026" />
                <meta property="og:title" content="Débarras Quai de la Touques – Deauville | CC Débarras 14" />
                <meta property="og:description" content="Photos avant/après du débarras sur le quai de la Touques à Deauville, janvier 2026." />
                <meta property="og:url" content="https://ccdebarras14.fr/avant-apres/deauville-janvier-2026" />
                <meta property="og:type" content="article" />
            </Helmet>

            <Header />

            <div className="before-after-component ba-page">
                <div className="before-after-content">
                    <div className="gallery-back-link">
                        <a href="/avant-apres" className="gallery-back-button">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M19 12H5M12 19l-7-7 7-7"></path>
                            </svg>
                            Retour aux débarras
                        </a>
                    </div>

                    <header className="ba-hero">
                        <span className="ba-hero-eyebrow">Janvier 2026</span>
                        <h1>Deauville</h1>
                        <p>Quai de la Touques</p>
                    </header>

                    <div className="ba-grid">
                        {images.map((image, idx) => (
                            <article key={image} className="ba-card">
                                <button type="button" className="ba-card-media" onClick={() => setOpenIndex(idx)} aria-label={`Agrandir la photo ${idx + 1}`}>
                                    <img
                                        src={`${IMAGE_DIR}/${image}`}
                                        alt={`Avant / après débarras Deauville - vue ${idx + 1}`}
                                        loading="lazy"
                                    />
                                    <span className="ba-tag ba-tag--before">Avant</span>
                                    <span className="ba-tag ba-tag--after">Après</span>
                                </button>
                            </article>
                        ))}
                    </div>

                    <section className="ba-cta">
                        <h2>Un logement à vider&nbsp;?</h2>
                        <p>Visite et devis gratuits, débarras gratuit sous conditions.</p>
                        <a href="/contact" className="ba-cta-button">Demander un devis</a>
                    </section>
                </div>
            </div>

            {openIndex !== null && (
                <div className="ba-lightbox" role="dialog" aria-modal="true" aria-label="Photo avant / après" onClick={close}>
                    <button type="button" className="ba-lightbox-close" onClick={close} aria-label="Fermer">×</button>
                    <button type="button" className="ba-lightbox-nav ba-lightbox-nav--prev" onClick={(e) => { e.stopPropagation(); prev(); }} aria-label="Précédent">‹</button>
                    <figure className="ba-lightbox-figure" onClick={(e) => e.stopPropagation()}>
                        <div className="ba-lightbox-media">
                            <img src={`${IMAGE_DIR}/${images[openIndex]}`} alt={`Avant / après débarras Deauville - vue ${openIndex + 1}`} />
                            <span className="ba-tag ba-tag--before">Avant</span>
                            <span className="ba-tag ba-tag--after">Après</span>
                        </div>
                        <figcaption>
                            <span>Quai de la Touques · Deauville — Janvier 2026</span>
                            <span className="ba-lightbox-count">{openIndex + 1} / {images.length}</span>
                        </figcaption>
                    </figure>
                    <button type="button" className="ba-lightbox-nav ba-lightbox-nav--next" onClick={(e) => { e.stopPropagation(); next(); }} aria-label="Suivant">›</button>
                </div>
            )}

            <Footer />
        </>
    );
};

export default DeauvilleJanuary2026;
